const {
  readField,
  readMarkdown,
  readBoolean,
  loadSubItems,
} = require('../fields/index')
const common = require('./common')

const component = (subField, loc = 'en=AU') => ({
  ...common(subField, null, subField.fields.title, loc),
  title: readField(subField.fields.title, loc),
  body: readMarkdown(subField.fields.body, loc),
  icon: readField(subField.fields.icon, loc),
  style: readField(subField.fields.style, loc),
  backgroundColor: readField(subField.fields.backgroundColor, loc),
  maxHeight: readBoolean(subField.fields.maxHeight, loc),
  iconPosition: readField(subField.fields.iconPosition, loc),
  subItems: loadSubItems(readField(subField.fields.subItems, loc)),
  options: readField(subField.fields.options, loc),
})

module.exports = component
module.exports.tryLoad = (subField, loc = 'en-AU') => {
  if (subField.sys.contentType.sys.id === 'boxedContent') {
    return component(subField, loc)
  }
  return null
}

module.exports.load = (data, loc = 'en-AU') => {
  const locations = data.entries.filter(
    e => e.sys.contentType.sys.id === 'boxedContent'
  )

  const processedLocations = locations.map(l => component(l, loc))
  const result = {}
  processedLocations.forEach(l => {
    result[l.id] = l
    result[l.title] = l
  })
  return result
}
